import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberpipe',
})
export class NumberPipe implements PipeTransform {

  transform(number: any, type: string, separator?: string): any {
    const objectNumber = number.toString().split(/(?=(?:...)*$)/);
    let cadena = '';
    switch (type) {
      case 'document':
        for (let i = 0; i < objectNumber.length; i++) {
          if (i < objectNumber.length - 1) {
            cadena += objectNumber[i] + separator;
          } else {
            cadena += objectNumber[i];
          }
        }
        break;
      case 'phone':
        cadena = number.replace(/(\d\d\d)(\d\d\d)(\d\d)(\d\d)/, '$1 $2 $3 $4');
        break;
      default:
        break;
    }
    return cadena;
  }
}
